// TODO ¿Es necesario? Se llama desde el src/index.jsx pero no se si hace algo a estas alturas
export default function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister()
    })
  }
}
